export const BLANK_PAGE_SKELETON =
`<div class="container">
    <div class="row">
        <div class="col-sm-4"></div>
        <div class="col-sm-4"></div>
        <div class="col-sm-4"></div>
    </div>
</div>`;
